import React, { FC, memo } from "react";

import { Container, ContainerDivider } from "./styled";
import { ContainerProps } from "../types";

export const DividerContainer: FC<ContainerProps> = memo(({ elementConfig }) => {
  return (
    <Container style={elementConfig?.style}>
      <ContainerDivider $bgColor={elementConfig?.options?.bgColor} />
    </Container>
  );
});
